export default function Gallery() {
  const exchanges = [
    {
      id: 1,
      beforeImage: 'https://public.readdy.ai/ai/img_res/51501fe1f14c16c6473c9c68c029ac45.jpg',
      afterImage: 'https://readdy.ai/api/search-image?query=Modern%20ergonomic%20office%20desk%20chair%20in%20teal%20color%2C%20contemporary%20design%2C%20comfortable%20seating%2C%20home%20office%20furniture%2C%20clean%20minimal%20background%2C%20sustainable%20furniture%20exchange%2C%20professional%20quality&width=600&height=700&seq=gallery-after-001&orientation=portrait',
      swapper: 'Emma & David',
      location: 'Portland, OR',
      items: 'Bookshelf ↔ Office Chair'
    },
    {
      id: 2,
      beforeImage: 'https://readdy.ai/api/search-image?query=Collection%20of%20vintage%20vinyl%20records%20spread%20out%20on%20wooden%20surface%2C%20classic%20music%20albums%2C%20retro%20entertainment%2C%20nostalgic%20items%2C%20warm%20lighting%2C%20simple%20background%20highlighting%20the%20records%2C%20sustainable%20exchange&width=600&height=700&seq=gallery-before-002&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=Professional%20DSLR%20camera%20with%20lens%20on%20clean%20surface%2C%20modern%20photography%20equipment%2C%20high%20quality%20camera%20gear%2C%20minimal%20background%2C%20sustainable%20technology%20exchange%2C%20well-maintained%20condition&width=600&height=700&seq=gallery-after-002&orientation=portrait',
      swapper: 'Marcus & Lisa',
      location: 'Austin, TX',
      items: 'Vinyl Collection ↔ Camera'
    },
    {
      id: 3,
      beforeImage: 'https://readdy.ai/api/search-image?query=Colorful%20children%20toys%20and%20games%20neatly%20arranged%2C%20educational%20toys%2C%20kids%20play%20items%2C%20bright%20cheerful%20colors%2C%20clean%20organized%20display%2C%20simple%20background%2C%20sustainable%20toy%20exchange&width=600&height=700&seq=gallery-before-003&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=Acoustic%20guitar%20leaning%20against%20wall%20in%20warm%20lighting%2C%20beautiful%20wooden%20instrument%2C%20musical%20equipment%2C%20natural%20wood%20finish%2C%20simple%20clean%20background%2C%20sustainable%20music%20exchange&width=600&height=700&seq=gallery-after-003&orientation=portrait',
      swapper: 'Sarah & Tom',
      location: 'Seattle, WA',
      items: 'Kids Toys ↔ Guitar'
    },
    {
      id: 4,
      beforeImage: 'https://readdy.ai/api/search-image?query=Vintage%20kitchen%20appliances%20including%20mixer%20and%20blender%20on%20countertop%2C%20retro%20kitchen%20equipment%2C%20well-maintained%20appliances%2C%20warm%20home%20setting%2C%20simple%20background%20highlighting%20items%2C%20sustainable%20exchange&width=600&height=700&seq=gallery-before-004&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=Set%20of%20camping%20gear%20including%20tent%20and%20backpack%2C%20outdoor%20adventure%20equipment%2C%20hiking%20essentials%2C%20organized%20display%2C%20natural%20lighting%2C%20simple%20background%2C%20sustainable%20outdoor%20exchange&width=600&height=700&seq=gallery-after-004&orientation=portrait',
      swapper: 'Rachel & Mike',
      location: 'Denver, CO',
      items: 'Kitchen Set ↔ Camping Gear'
    },
    {
      id: 5,
      beforeImage: 'https://readdy.ai/api/search-image?query=Stack%20of%20hardcover%20books%20and%20novels%20on%20wooden%20table%2C%20literature%20collection%2C%20reading%20materials%2C%20cozy%20home%20library%2C%20warm%20lighting%2C%20simple%20background%20highlighting%20books%2C%20sustainable%20exchange&width=600&height=700&seq=gallery-before-005&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=Yoga%20mat%20and%20meditation%20cushion%20set%20in%20peaceful%20setting%2C%20wellness%20equipment%2C%20fitness%20accessories%2C%20calming%20colors%2C%20minimal%20zen%20background%2C%20sustainable%20wellness%20exchange&width=600&height=700&seq=gallery-after-005&orientation=portrait',
      swapper: 'Nina & Alex',
      location: 'San Francisco, CA',
      items: 'Book Collection ↔ Yoga Set'
    },
    {
      id: 6,
      beforeImage: 'https://readdy.ai/api/search-image?query=Vintage%20bicycle%20in%20good%20condition%20against%20simple%20background%2C%20classic%20bike%20design%2C%20sustainable%20transportation%2C%20well-maintained%20bicycle%2C%20clean%20minimal%20setting%2C%20eco-friendly%20exchange&width=600&height=700&seq=gallery-before-006&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=Electric%20keyboard%20piano%20on%20stand%2C%20modern%20musical%20instrument%2C%20digital%20piano%2C%20home%20music%20setup%2C%20clean%20background%2C%20sustainable%20music%20equipment%20exchange&width=600&height=700&seq=gallery-after-006&orientation=portrait',
      swapper: 'Chris & Jordan',
      location: 'Boston, MA',
      items: 'Bicycle ↔ Keyboard'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="w-2 h-2 bg-teal-600 rounded-full"></div>
            <span className="text-teal-600 text-xs font-semibold tracking-widest uppercase">Success Stories</span>
          </div>
          
          <h2 className="text-5xl md:text-6xl font-serif font-bold text-gray-900 mb-6 leading-tight">
            Real Swaps,<br />Real Impact
          </h2>
          
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            See how our community members are transforming their lives through sustainable exchanges. Every swap tells a story of connection, sustainability, and shared value.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {exchanges.map((exchange) => (
            <div 
              key={exchange.id}
              className="group bg-gray-50 rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-80 overflow-hidden">
                <div className="absolute inset-0 grid grid-cols-2">
                  <div className="relative overflow-hidden">
                    <img
                      src={exchange.beforeImage}
                      alt="Before swap"
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                      <span className="text-xs font-semibold text-gray-700">Before</span>
                    </div>
                  </div>
                  
                  <div className="relative overflow-hidden">
                    <img
                      src={exchange.afterImage}
                      alt="After swap"
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 right-4 bg-teal-600 px-3 py-1 rounded-full">
                      <span className="text-xs font-semibold text-white">After</span>
                    </div>
                  </div>
                </div>

                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-xl">
                    <i className="ri-arrow-left-right-line text-2xl text-teal-600"></i>
                  </div>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-user-smile-line text-teal-600"></i>
                  <span className="font-semibold text-gray-900">{exchange.swapper}</span>
                </div>
                
                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-map-pin-line text-gray-400 text-sm"></i>
                  <span className="text-sm text-gray-600">{exchange.location}</span>
                </div>

                <div className="bg-teal-50 rounded-xl p-3 text-center">
                  <p className="text-sm font-medium text-teal-900">{exchange.items}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <button className="bg-teal-600 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-teal-700 transition-all flex items-center gap-2 mx-auto whitespace-nowrap shadow-lg hover:shadow-xl cursor-pointer">
            View All Success Stories
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
